import * as React from 'react';
import { withStyles, CircularProgress, List, Checkbox, Dialog, DialogContent, Button, DialogActions, DialogTitle, createStyles, Chip, Avatar, } from '@material-ui/core';
import { combineContainers } from 'combine-containers';
import { graphql } from 'react-apollo';
import { graphqlQueryHelper } from '../graphql/graphql-query-helper';
import EntityListItem from '../entities/EntityListItem';
import { entityService } from '../entities/services/entity-service';
import 'pluralize';
import AddCircle from '@material-ui/icons/AddCircle';
import { withCoreContext } from '../context/with-core-context';
const styles = (theme) => createStyles({
    editor: {
        width: '100%',
    },
    textLink: {
        cursor: 'pointer',
        color: theme.palette.secondary.main,
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    chip: {
        margin: theme.spacing(),
    },
});
class MultipleEntityPickerEditor extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            dialogOpen: false,
        };
        this.handleOnChange = ({ entity }) => () => {
            const { setValue, value, max } = this.props;
            const selectedEntityIds = value || [];
            const checked = this.isChecked({ entity });
            if (checked) {
                setValue(selectedEntityIds.filter((id) => id !== entity._id));
            }
            else if (!max || (value || []).length < max) {
                setValue([...selectedEntityIds, entity._id]);
            }
        };
        this.isChecked = ({ entity }) => {
            const selectedEntityIds = this.props.value || [];
            return selectedEntityIds.some((id) => entity._id === id);
        };
    }
    render() {
        const { classes, value, data, setValue, schema, context, max } = this.props;
        if (data.loading) {
            return React.createElement(CircularProgress, null);
        }
        const selectedEntityIds = value || [];
        const instanceDisplayProps = entityService.instanceDisplayPropsOrDefault(schema, context);
        return data.items ? (React.createElement("div", null,
            value ? (React.createElement(React.Fragment, null, selectedEntityIds.map((id) => {
                const match = data.items ? data.items.find((entity) => entity._id === id) : undefined;
                const url = match ? instanceDisplayProps(match).imageUrl : undefined;
                return match ? (React.createElement(Chip, { key: id, avatar: url ? React.createElement(Avatar, { src: instanceDisplayProps(match).imageUrl }) : undefined, label: instanceDisplayProps(match).primaryText, onDelete: this.handleOnChange({ entity: match }), className: classes.chip })) : (React.createElement("span", null));
            }))) : (React.createElement("span", null)),
            (!max || selectedEntityIds.length < max) && (React.createElement(Chip, { icon: React.createElement(AddCircle, null), color: "secondary", label: `Select ${schema.options.displayName}`, className: classes.chip, onClick: () => this.setState({ dialogOpen: true }) })),
            React.createElement(Dialog, { open: this.state.dialogOpen, fullWidth: true, maxWidth: "sm" },
                React.createElement(DialogTitle, null,
                    "Select a ",
                    schema.options.displayName),
                React.createElement(DialogContent, null,
                    React.createElement(List, null, data.items.map((entity) => {
                        return (React.createElement(EntityListItem, { entity: entity, schema: schema, key: entity._id, button: true, onClick: this.handleOnChange({ entity }), SecondaryAction: React.createElement(Checkbox, { onChange: this.handleOnChange({ entity }), checked: this.isChecked({ entity }) }) }));
                    }))),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { onClick: () => this.setState({ dialogOpen: false }) }, "Done"))))) : (React.createElement("div", null, "None found"));
    }
}
export default (options) => {
    const ENTITY_PICKER_QUERY = graphqlQueryHelper.getAllQueryWithAllFields(options.schema);
    const Editor = combineContainers(withCoreContext, withStyles(styles), graphql(ENTITY_PICKER_QUERY, {
        options: {
            fetchPolicy: 'network-only',
            variables: {
                filter: {},
                sort: {},
                pagination: {
                    limit: 50,
                    skip: 0,
                },
            },
        },
    }))(MultipleEntityPickerEditor);
    return (props) => React.createElement(Editor, Object.assign({}, props, options));
};
